import { z } from 'zod';

export const InputSchema = z.object({
    perPage: z.number(),
    page: z.number(),
    channel: z.string()
});

export type TInputSchema = z.infer<typeof InputSchema>;

export const SuccessResponseSchema = z.array(
    z.object({
        id: z.string(),
        universeId: z.string(),
        type: z.string(),
        status: z.string(),
        accountName: z.string(),
        accountId: z.number(),
        details: z.object({
            firstName: z.string(),
            surname: z.string(),
            // pid: z.string(),
            titlesOfPEPs: z.array(z.string()).optional(),
            titlesOfSanctions: z.array(z.string()).optional(),
        }),
        channels: z.array(z.string()),
        createdAt: z.string(), // date
    }),
);

export type TSuccessResponse = z.infer<typeof SuccessResponseSchema>;

export type TResponseType =
    { responseStatus: 'success'; data: TSuccessResponse } |
    {
        responseStatus: 'apiError',
        status: number,
        data?: unknown
    }
